
function vueGetTag(vueComponent) {
  return vueComponent.$options._componentTag
}

function vueGetUid(vueComponent) {
  return vueComponent._uid
}

function vueFindAncestor(vueComponent, name) {
  let parent = vueComponent.$parent
  while(parent && name !== vueGetTag(parent)) {
    parent = parent.$parent
  }
  return parent
}

function *vueFindChildren(vueComponent, name) {
  for(const child of vueComponent.$children) {
    if(name === vueGetTag(child)) {
      yield child
    }
  }
}

function *vueFindProgeny(vueComponent, name) {
  for(const child of vueComponent.$children) {
    if(name === vueGetTag(child)) {
      yield child
    }
    yield* vueFindProgeny(child, name)
  }
}

export {
  vueGetTag,
  vueGetUid,
  vueFindAncestor,
  vueFindChildren,
  vueFindProgeny,
}
